import { createBrowserHistory } from 'history';

export default function(API) {

	const createHistory = createBrowserHistory;
	const history = createHistory();

	//=============================================================
	// Instances
	//=============================================================

	API.registerInstance('history', history);

	//=============================================================
	// API binds
	//=============================================================

	API.redirect = (location, replace = false) => {

		if(replace)
			window.location.replace(location);
		else
			window.location.href = location;
	}
}
